// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__iSLIi","leftTop":"index_leftTop__ewhO2","leftBottom":"index_leftBottom__aSyTT","rightTop":"index_rightTop___v4Hj","rightBottom":"index_rightBottom__866b_"};